import React from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { HotTable } from "@handsontable/react";
import { utils } from "~/utils";
import swal from "sweetalert";
import { ClipLoader } from "react-spinners";
import "../../../sode/oet/components/oet_history_modal.scss";

const getColHeaders = (props) => {
    if (props.headers) {
        return props.headers
    }
    const headers = [
        "Confirmation", "Process",
        "Items", "Amended qty",
        "Amended unit price", "User", "Date"
    ]
    return headers
}

const getColumns = (props) => {
    if (props.columns) {
        return props.columns
    }
    const res = [
        {
            data: "gr_confirmation",
            editor: false,
        },
        {
            data: "process",
            editor: false,
        },
        {
            data: "fb_items",
            editor: false,
            className: "htMiddle htMiddle"
        },
        {
            data: 'qty',
            editor: false,
            className: "htMiddle htMiddle"
        },
        {
            data: 'unit_price',
            editor: false,
            className: "htMiddle htMiddle"
        },
        {
            data: "user",
            editor: false,
            className: "htRight htMiddle"
        },
        {
            data: "date_response",
            editor: false,
            className: "htRight htMiddle"
        }
    ];
    return res;
};
export default class SAPModalHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            loading: false,
        };

    }

    getData = () => {
        const { status } = this.props
        if (status >= 6) {
            this.props
                .onSubmit()
                .then((results) => {
                    this.data = results
                    this.setState({ loading: false });
                })
                .catch(error => {
                    this.setState({ loading: false });
                    swal({
                        title: "Error!",
                        text: utils.computeError(error),
                        icon: "error",
                        button: true
                    });
                });
        }

    }

    close = () => {
        this.setState({
            modal: false
        });
    };

    open = () => {
        this.setState({
            modal: true,
            loading: true,
        });
        this.getData();
    };

    toggle = () => {
        const modal = !this.state.modal;
        if (modal) {
            this.open();
        } else {
            this.close();
        }
    };

    getModalBodyElement = () => {
        if (this.state.loading) {
            return <ClipLoader size={38} color={"#007bff"} />
        } else {
            if (this.data) {
                return <HotTable
                    tableClassName="table table-bordered table-striped"
                    data={this.data}
                    rowHeaders={false}
                    height="250"
                    width="100%"
                    stretchH="all"
                    colHeaders={getColHeaders(this.props)}
                    columns={getColumns(this.props)}
                />
            } else {
                return <p>No history</p>
            }
        }
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.state.modal} style={{ width: 800 }}>
                    <ModalHeader>{'History'}</ModalHeader>
                    <ModalBody>
                        {this.getModalBodyElement()}
                    </ModalBody>
                    <ModalFooter>
                        <Button className="btn-danger" onClick={this.toggle} type="button" name="Close">
                            Close
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}
